// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._kqswh2mm{position:relative}
._p12f1osq{max-width:100%}`, "",{"version":3,"sources":["webpack://./node_modules/@atlaskit/inline-edit/dist/esm/inline-edit.compiled.css"],"names":[],"mappings":"AAAA,WAAW,iBAAiB;AAC5B,WAAW,cAAc","sourcesContent":["._kqswh2mm{position:relative}\n._p12f1osq{max-width:100%}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
